import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export function NavDebug() {
  const location = useLocation();
  const navType = useNavigationType(); // POP, PUSH, REPLACE

  useEffect(() => {
    // Log every route change with stack trace
    console.groupCollapsed(
      `%cNAV ${navType} -> ${location.pathname}${location.search}${location.hash}`,
      "color:#9b8fc4;font-weight:bold;"
    );
    console.trace("Navigation stack trace");
    console.groupEnd();
  }, [location.key]); // key changes on navigation

  useEffect(() => {
  const origPush = history.pushState;
  const origReplace = history.replaceState;

  history.pushState = function (...args) {
    console.groupCollapsed("%cHISTORY pushState", "color:#22c55e;font-weight:bold;");
    console.trace();
    console.groupEnd();
    // @ts-ignore
    return origPush.apply(this, args);
  };

  history.replaceState = function (...args) {
    console.groupCollapsed("%cHISTORY replaceState", "color:#ef4444;font-weight:bold;");
    console.trace();
    console.groupEnd();
    // @ts-ignore
    return origReplace.apply(this, args);
  };

  return () => {
    history.pushState = origPush;
    history.replaceState = origReplace;
  };
}, []);

  return null;
}